import React from "react";

export default class ReadMoreBtn extends React.Component {

    render() {
        return (
            <div className="read-more-btn">Подробнее</div>
        );
    }
}
